import { defineComponent as _defineComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'CategoryLabel',
  props: {
    label: { type: String, required: true },
    isActive: { type: Boolean, required: false }
  },
  emits: ["selected"],
  setup(__props: any, { expose: __expose }) {
  __expose();





const __returned__ = {  }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})

//@ sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImxpYnMvZmVhdHVyZS9wcm9kdWN0LWNvbmZpZ3VyYXRvci9zcmMvbGliL3Z1ZS1hcHBzL3Vwc2VsbHMvY29tcG9uZW50cy9DYXRlZ29yeUxhYmVsLnZ1ZSJdLCJzb3VyY2VzQ29udGVudCI6WyI8c2NyaXB0IGxhbmc9XCJ0c1wiIHNldHVwPlxuZGVmaW5lUHJvcHM8e1xuICBsYWJlbDogc3RyaW5nO1xuICBpc0FjdGl2ZT86IGJvb2xlYW47XG59PigpO1xuXG5kZWZpbmVFbWl0czx7IHNlbGVjdGVkOiBbXSB9PigpO1xuPC9zY3JpcHQ+XG5cbjx0ZW1wbGF0ZT5cbiAgPGxhYmVsIGNsYXNzPVwidXBzZWxscy1jYXRlZ29yeS10YWcgY29uZmlndXJhdG9yLXVwc2VsbHNfZmlsdGVyXCIgQGNoYW5nZS5wcmV2ZW50PVwiJGVtaXQoJ3NlbGVjdGVkJylcIj5cbiAgICA8c3Bhbj57eyBsYWJlbCB9fTwvc3Bhbj5cblxuICAgIDxpbnB1dCB0eXBlPVwicmFkaW9cIiBuYW1lPVwiY2FyZC1jYXRlZ29yeS10YWdcIiA6dmFsdWU9XCJsYWJlbFwiIDpjaGVja2VkPVwiaXNBY3RpdmVcIiAvPlxuICA8L2xhYmVsPlxuPC90ZW1wbGF0ZT5cbiJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7In0=